import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function AccurateCallback() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("processing"); // processing | ok | error
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    (async () => {
      const code = params.get("code");
      const err = params.get("error");
      if (err) {
        if (alive) {
          setStatus("error");
          setMessage(`Accurate menolak otorisasi: ${err}`);
        }
        return;
      }
      if (!code) {
        if (alive) {
          setStatus("error");
          setMessage("Kode otorisasi tidak ditemukan.");
        }
        return;
      }
      try {
        const redirect_uri = window.location.origin + "/oauth/accurate/callback";
        await api.post("/oauth/accurate/exchange", { code, redirect_uri });
        if (alive) {
          setStatus("ok");
          setMessage("Otorisasi berhasil. Mengarahkan kembali ke Settings...");
          setTimeout(() => navigate("/settings"), 1500);
        }
      } catch (e) {
        if (alive) {
          setStatus("error");
          setMessage(e.response?.data?.detail || e.message);
        }
      }
    })();
    return () => { alive = false; };
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] p-6">
      <div className="bg-white border border-[#E2E8F0] rounded-lg p-8 max-w-md w-full text-center">
        {status === "processing" && (
          <>
            <Loader2 className="w-10 h-10 animate-spin text-[#0066FF] mx-auto mb-4" />
            <h1 className="text-lg font-medium text-[#0F172A]">Menukar kode otorisasi...</h1>
            <p className="text-sm text-[#64748B] mt-2">Mohon tunggu sebentar.</p>
          </>
        )}
        {status === "ok" && (
          <>
            <CheckCircle2 className="w-10 h-10 text-[#059669] mx-auto mb-4" />
            <h1 className="text-lg font-medium text-[#0F172A]">Accurate Terhubung</h1>
            <p className="text-sm text-[#64748B] mt-2">{message}</p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="w-10 h-10 text-[#DC2626] mx-auto mb-4" />
            <h1 className="text-lg font-medium text-[#0F172A]">Gagal Menghubungkan</h1>
            <p className="text-sm text-[#64748B] mt-2 break-words">{message}</p>
            <button
              onClick={() => navigate("/settings")}
              className="mt-4 bg-[#0A2540] text-white hover:bg-[#1E3A8A] rounded-md px-4 py-2 text-sm font-medium transition-colors"
            >
              Kembali ke Settings
            </button>
          </>
        )}
      </div>
    </div>
  );
}
